export default __webpack_public_path__ + "static/media/body_organ_limbs.24b24d62.png";